module.exports = __webpack_public_path__ + "static/media/GABA_Post_2018.09.26-4.0885bad7.jpg";